import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fillRule="evenodd"
      d="M13.792 1.463a2.798 2.798 0 0 1 4.044 2.51v.145c.035-.005 3.232-.475 6.016 1.178a.23.23 0 0 1 .11.256c-.252.983-1.84 6.135-8.295 9.91l-.374 5.994 1.23-.02a.735.735 0 0 1 .05 1.47H12.93l.741-5.172c.008-.03.787-3.18-1.125-4.921-.712-.627-1.719-1.094-3.812-.454-1.487.506-2.371 1.268-3.947 2.506a.17.17 0 0 0-.056.183c.035.11.169.153.263.088.614-.429 2.635-1.72 4.979-1.907a2.47 2.47 0 0 1 2.696 2.043c.344 2.373-1.804 5.152-2.602 6.092l1.603-.004a.783.783 0 0 1 .004 1.566H.23C.223 22.886-2.634 8.032 12.252 5.09a4.3 4.3 0 0 1 .155-2.052c.239-.685.736-1.25 1.385-1.575m1.258 1.35a1.15 1.15 0 1 0 0 2.3 1.15 1.15 0 0 0 0-2.3"
      clipRule="evenodd"
    />
  </>
);

const CollWildlife = Icon('coll-wildlife', svgContents);

export default CollWildlife;
